<div class="card">
  <app-header titulo="Municípios" descricao="Integração de municípios"></app-header>

  <p-table [value]="municipios" [globalFilterFields]="['cdMunicIbge','cdUf','deMunic','cdMunic']"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
           [rowsPerPageOptions]="[10,20,50,100]" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
           currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" dataKey="cdMunicIbge" #dt>

    <ng-template pTemplate="caption">
      <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center">
          <button class="ml-3 mr-3" pButton (click)="exportar()" style="font-size: 1.0rem" [loading]="loadingSincronizar" icon="pi pi-file-excel" label="Exportar"></button>
        </div>
        <div class="flex align-items-center justify-content-center">
          <span class="p-input-icon-left ml-auto">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
          </span>
        </div>
        <div class="flex align-items-center justify-content-center">
          <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="getAll()" [loading]="loading"></button>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th>Município (IBGE)</th>
        <th>UF</th>
        <th>Descrição</th>
        <th>Dt Recebido</th>
        <th>Status</th>
        <th>Dt Integrado</th>
        <th>Mensagem</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-municipio>
      <tr>
        <td>{{ municipio.cdMunicIbge }}</td>
        <td>{{ municipio.cdUf }}</td>
        <td>{{ municipio.deMunic }}</td>
        <td>{{ municipio.dtRecebido | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td><app-tag-status [status]="municipio.fgStatusInteg"></app-tag-status></td>
        <td>{{ municipio.dtIntegPims | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ municipio.deMensagemInteg }}</td>
      </tr>
    </ng-template>

  </p-table>
</div>
